import React from "react";
import Navbar from "../../component/Navbar/Navbar";
import SidebarSetting from "../../component/SidebarSetting/SidebarSetting";
import Users from "../../component/users/Users";

const User = () => {

  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1]">
      <div>
        <Navbar page="Settings" />
      </div>
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div className="lg:w-[30%] md:w-[39%] w-[35%] bg-white shadow-md">
          <SidebarSetting />
        </div>

        {/* Main Content */}
        <div className="flex-1 md:p-8 py-6 px-4  relative overflow-y-auto">
          <div className="md:w-full w-[27rem] mx-auto">
            <Users />
          </div>
        </div>
      </div>
    </div>
  );
};

export default User;
